export default __webpack_public_path__ + "static/media/tablero_icon_white.5678ccb4.svg";